import { useMemo } from 'react';
import { trpc } from '../lib/trpc';
import { createPasswordAuthAdapter } from '../lib/auth';

/**
 * Provides password auth adapter and mutation state for login/signup screens.
 * Use with useAuth().persistAndSetAuth for token persistence.
 */
export function usePasswordAuth() {
  const login = trpc.auth.login.useMutation();
  const signup = trpc.auth.signup.useMutation();
  const passwordAuth = useMemo(
    () =>
      createPasswordAuthAdapter({
        loginMutation: { mutateAsync: login.mutateAsync },
        signupMutation: { mutateAsync: signup.mutateAsync },
      }),
    [login.mutateAsync, signup.mutateAsync]
  );
  return {
    passwordAuth,
    isPending: login.isPending || signup.isPending,
    loginError: login.error,
    signupError: signup.error,
  };
}
